import { createModelStore } from '@/shared/stores/create-model-store'
import { model17InitialModel } from './initial-state'
import { model17DimensionHandlers } from './dimensions'

export const useModel17Store = createModelStore({
  initialModel: model17InitialModel,
  dimensionHandlers: model17DimensionHandlers,
})
